import { Reducer } from 'redux'
import Cookies from 'universal-cookie'
import * as actions from './actions'

export const cookies = new Cookies()

export type SessionState = Readonly<{
  id: string | null
  userId: string | null
}>

export const initState: SessionState = {
  id: null,
  userId: null
}

// reducer
export const sessionReducer: Reducer<SessionState, actions.SessionActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.SET: {
      const { id, userId } = action.payload.session
      // localStorage.setItem('id', id)
      // localStorage.setItem('uid', userId)
      cookies.set('sid', id, { path: '/' })
      cookies.set('uid', userId, { path: '/' })
      return {
        ...state,
        id,
        userId
      }
    }

    case actions.RESTORE: {
      const id = cookies.get('sid') // localStorage.getItem('id')
      const userId = cookies.get('uid') // localStorage.getItem('uid')

      return {
        ...state,
        id,
        userId
      }
    }

    case actions.CLEAR: {
      // localStorage.clear()
      cookies.remove('sid')
      cookies.remove('uid')
      return initState
    }
    default:
      return state
  }
}
